// play() rejections that are expected when the browser blocks or interrupts playback
const EXPECTED_PLAY_ERRORS = ["AbortError", "NotAllowedError", "NotSupportedError"];

export function isExpectedPlayError(err: unknown): boolean {
  return EXPECTED_PLAY_ERRORS.includes((err as Error)?.name);
}

/** Starts playback, ignoring the expected rejections so they are not reported as errors. */
export function playQuietly(player: { play(): Promise<void> | undefined } | null | undefined): void {
  player?.play()?.catch((err: unknown) => {
    if (!isExpectedPlayError(err)) throw err;
  });
}
